<template>
  <span>{{ displayAmount }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { toPersianDigits } from "@/core/utilities";
import type { MoneyType } from "@/core/api/graphql/types";

interface IProps {
  value?: Pick<MoneyType, "formattedAmount">;
}

const props = defineProps<IProps>();

const { locale } = useI18n();

const displayAmount = computed(() => {
  if (!props.value?.formattedAmount) {
    return "N/A";
  }

  // Convert to Persian digits first
  let amount = locale.value === "fa" || locale.value === "fa-IR"
    ? toPersianDigits(props.value.formattedAmount)
    : props.value.formattedAmount;

  // Remove .00, /۰۰, ٫۰۰, ,۰۰ decimal patterns (guard against both ASCII and Persian digits)
  // amount = amount.replace(/[\.\/٫,]۰۰(?![\d۰-۹])|\.00(?!\d)/g, "");

  return amount;
});
</script>
